import { 
  DialogContent, DialogActions, Button, Checkbox, 
  FormControlLabel, Select, MenuItem, FormControl, InputLabel, Box, Typography 
} from "@mui/material";
import { useState, useEffect } from "react";

export default function SimpleView({ row, rnrs, onOpenSplit, onClose, onConfirm, onUpgrade, onDowngrade, onRemove }) {
  const [useParty, setUseParty] = useState(row.matchLevel === "GREEN");
  const [rnr, setRnr] = useState(row?.rnr || "");
  const hasFilter = !!row.filterId;

  useEffect(() => {
    setUseParty(row.matchLevel === "GREEN");
    setRnr(row.rnr || "");
  }, [row]);

  const handleConfirm = () => {
    if (!rnr) return;
    onConfirm(row, useParty ? "GREEN" : "YELLOW", rnr);
  };

  return (
    <>
      <DialogContent dividers>
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>{row.name}</Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>{row.description}</Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <FormControlLabel control={<Checkbox checked disabled />} label="Suund (Debit/Credit)" />
          <FormControlLabel control={<Checkbox checked disabled />} label="Selgitus (Märksõna)" />
          <FormControlLabel
            control={<Checkbox checked={useParty} onChange={(e) => setUseParty(e.target.checked)} />}
            label="Saaja nimi / IBAN (Green filter)"
          />
        </Box>

        <FormControl fullWidth margin="normal" required error={!rnr}>
          <InputLabel>RNR Kood</InputLabel>
          <Select value={rnr} label="RNR Kood" onChange={(e) => setRnr(e.target.value)}>
            <MenuItem value="">Määramata</MenuItem>
            {rnrs?.map((r) => (
              <MenuItem key={r.code} value={r.code}>{r.code} – {r.description}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'space-between', px: 3 }}>
        <Box>
          {hasFilter && (
            <Button color="error" size="small" onClick={() => onRemove(row)}>Eemalda filter</Button>
          )}
        </Box>
        <Box>
          <Button onClick={onClose}>Tühista</Button>
          <Button onClick={onOpenSplit} color="secondary">Tükelda summa</Button>
          <Button onClick={handleConfirm} variant="contained" disabled={!rnr} sx={{ ml: 1 }}>
            {hasFilter ? "Salvesta" : "Loo filter"}
          </Button>
        </Box>
      </DialogActions>
    </>
  );
}